
import { useEffect, useRef } from "react";
import { Message } from "@/types/chat";

interface MessageListProps {
  messages: Message[];
  showMessages: boolean;
}

const MessageList = ({ messages, showMessages }: MessageListProps) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Scroll to bottom of messages container when messages change
    if (messagesEndRef.current && showMessages) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, showMessages]);

  if (!showMessages || messages.length === 0) return null;

  return (
    <div className="messages-container absolute top-0 right-full mr-4 max-h-96 w-80 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-lg z-50 animate-fade-in">
      <div className="p-4 space-y-4">
        {messages.map((message, index) => (
          <div 
            key={index} 
            className={`p-3 rounded-lg ${
              message.sender === "user" 
                ? "bg-gray-100 text-black ml-auto" 
                : "bg-black text-white"
            } max-w-[80%] ${message.sender === "user" ? "ml-auto" : "mr-auto"}`}
          >
            {message.text}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default MessageList;
